<script setup lang="ts">

import type { WizardNavigation } from "../Types/WizardNavigation";
const model = defineModel<WizardNavigation>( { required: true } );

</script>

<template>

    <div class="grid gap-0.5 w-full"
         :class="[ `grid-cols-${model.pages}` ]">
        <div v-for="page in model.pages"
             class="h-2 bg-gray-600"
             :class="{ '!bg-secondary-500': page - 1 == model.index }">
        </div>
    </div>

</template>